import { render, staticRenderFns } from "./ViewPaymentInvoiceModal.vue?vue&type=template&id=067657e2&scoped=true&"
import script from "./ViewPaymentInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./ViewPaymentInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067657e2",
  null
  
)

export default component.exports